//@flow
import * as React from 'react'
import type { DocRenderIframe$Props } from './flowTypes'

const DocRenderIframe=(props:DocRenderIframe$Props)=>{
    return (
        <div className="row">
            <div className="col-sm">
                <div className="embed-responsive embed-responsive-1by1" style={{height: '100%'}}>
                    <iframe className="embed-responsive-item" src={props.docUrl}></iframe>
                </div>
            </div>
        </div>
    )
}

export default DocRenderIframe


// WEBPACK FOOTER //
// ./src/views/ProjectKratosEC/DocRenderIframe.js